import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import TableHelper from 'helpers/Table';
import { Table, Badge } from 'antd';
import { Link } from 'react-router';
import { formatNumber, formatPvCode, getOrganicRevenue } from 'utils/formatting';
import formatDate from 'utils/formatDate';
import { orderBy } from 'lodash';
import { useState } from 'react';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const formatTime = (timeNumber) => {
  return moment(`${timeNumber}`, 'Hmm').format('HH:mm');
};
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const WithdrawalDetail = ({ withdrawal }) => {
  const [sortColumn, setSortColumn] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');
  if (!withdrawal) return <div></div>;
  const revenueSummaries = withdrawal.revenueSummaries;
  const content = orderBy(
    revenueSummaries.map((rs) => {
      rs.teachDate = moment(rs.schedule.end).format('DD/MM/YYYY');
      return rs;
    }),
    ['teachDate'],
    ['desc'],
  );
  const summaryData = content.reduce(
    (result, rs) => {
      result.paidPrice += rs.paidPrice;
      result.teacherRevenue += rs.teacherRevenue || 0;
      result.serviceFee += rs.serviceFee || 0;
      result.cardFee += rs.cardFee;
      result.organicRevenue += getOrganicRevenue(rs);
      return result;
    },
    {
      paidPrice: 0,
      teacherRevenue: 0,
      serviceFee: 0,
      cardFee: 0,
      organicRevenue: 0,
    },
  );
  content.push({
    rowType: 'Total',
    ...summaryData,
  });

  const pageLimit = 20;

  const onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    const _order = order === 'descend' ? 'desc' : 'asc';
    if (field === sortColumn) {
      setSortDirection(_order);
    } else {
      setSortColumn(field);
      setSortDirection(_order);
    }
    // if (order === 'descend') {
    //   setSortColumn
    //   setSortDirection
    //   this.setState({ sortBy: `-${field}` }, this.onSearch);
    // } else if (order === 'ascend') {
    //   this.setState({ sortBy: field }, this.onSearch);
    // }
  };

  return (
    <div className={cn('content')}>
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} rowKey="_id" onChange={onTableChange} />
      </div>
    </div>
  );
};

const columns = [
  {
    ...TableHelper.dateColumn('Sche.\nEnd Date', 'schedule.end'),
  },
  {
    ...TableHelper.defaultColumn('Class', 'class.name'),
    render: (value, record) => {
      if (!value) return '';
      return <Link to={`/class/${record.class._id}`}>{`${value}`}</Link>;
    },
  },
  {
    ...TableHelper.defaultColumn('Sche. No.', 'schedule.code'),
    render: (value, record) => {
      if (record.rowType === 'Total') return 'Total';
      return <Link to={`/class/${record.class._id}/schedule/${record.schedule._id}`}>{`${value}`}</Link>;
    },
  },
  {
    ...TableHelper.priceColumn("Teacher's\nRev", 'organicRevenue'),
    render: (value, record) => formatPrice(getOrganicRevenue(record)),
  },
  {
    ...TableHelper.percentColumn('%Com\nDisc', 'schedule.feeDiscount'),
    render: (value, record) => {
      if (record.rowType === 'Total') return '';
      return `${formatNumber(value, '0,0')}%`;
    },
  },
  {
    ...TableHelper.priceColumn('Net Com', 'serviceFee'),
  },
  {
    ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
  },
  {
    ...TableHelper.priceColumn('Payout', 'teacherRevenue'),
  },
  {
    ...TableHelper.defaultColumn(' ', ''),
    render: (value, record) => {
      if (!record.class) return '';
      return (
        <span>
          See <Link to={`/class/${record.class._id}/schedule/${record.schedule._id}?selectedTab=revenue`}>Detail</Link>{' '}
        </span>
      );
    },
  },
];

export default WithdrawalDetail;
